import React from 'react';
import styles from './FloFormControl.module.css';
import classnames from 'classnames';
import { FloComponentProps } from 'components';
import { Form } from 'react-bootstrap';

interface FloFormControlProps extends FloComponentProps {
  type:         string;
  placeholder?: string;
  onChange?:    any;
  onBlur?:      any;
  value:        string;
  isInvalid?:   boolean;
  disabled?:    boolean;
}

export const FloFormControl: React.FC<FloFormControlProps> =  React.memo(({className, isInvalid, ...props}) => {
  return (
    <Form.Control
      {...props}
      isInvalid = {isInvalid}
      className = {classnames(styles.root, className, {[styles.invalid]: isInvalid})}
    />
  );
});

export default FloFormControl;
